import React from 'react';
import { Button } from '../../../components/ui/button';
import SelectField from '../../../components/ui/select-field';

interface FiltersModalProps {
    open: boolean;
    onClose: () => void;
    selectedStatus: string;
    setSelectedStatus: (status: string) => void;
    statusOptions: string[];
    onClear: () => void;
    onApply: () => void;
}

const UsersFiltersModal: React.FC<FiltersModalProps> = ({
    open,
    onClose,
    selectedStatus,
    setSelectedStatus,
    statusOptions,
    onClear,
    onApply,
}) => {
    if (!open) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black bg-opacity-30 " onClick={onClose} />
            <div className="relative bg-white rounded-2xl shadow-lg w-[55vh] max-w-full flex flex-col">
                <div className="flex items-center bg-gray-100 rounded-tl-2xl rounded-tr-2xl justify-between px-6 py-4 border-b">
                    <span className="font-semibold text-lg text-maxi-text-dark">Filtros</span>
                    <Button
                        variant={"default"}
                        className="text-lg bg-primary rounded-full px-3 shadow"
                        onClick={onClose}
                    >
                        ×
                    </Button>
                </div>
                <div className="px-6 py-6 flex flex-col gap-6">
                    <div className="flex flex-row gap-6">
                        <SelectField
                            label="Estado"
                            name="status"
                            value={selectedStatus}
                            onChange={e => setSelectedStatus(e.target.value)}
                            options={[{ value: '', label: 'Selecciona estado' }, ...statusOptions.map(opt => ({ value: opt, label: opt }))]}
                            className="w-[30vh]"
                        />
                        <SelectField
                            label="Estado"
                            name="status"
                            value={selectedStatus}
                            onChange={e => setSelectedStatus(e.target.value)}
                            options={[{ value: '', label: 'Selecciona estado' }, ...statusOptions.map(opt => ({ value: opt, label: opt }))]}
                            className="w-[30vh]"
                        />
                    </div>
                    <div className="flex gap-3 justify-end mt-4">
                        <Button
                            variant={"secondary"}
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onClear}
                        >
                            Limpiar Filtros
                        </Button>
                        <Button
                            variant={"default"}
                            className="px-4 py-2 rounded-full px-6 font-medium hover:bg-gray-300"
                            onClick={onApply}
                        >
                            Aplicar
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UsersFiltersModal;
